import moment from 'moment';
import { apis } from '../../../config';
import { api } from '../../../api/api';
import { util } from '../../../api/util/index';
class IcsApiImpl {
    constructor() {
        this.name = apis.icsApiImpl;
        this.systemApi = api.getSystemApi();
        this.http = api.getDataTransApi();
        this.catalogApi = api.requireLogicalApi(apis.catalogApiImpl);
    }
    async getIcsParse(config) {
        const subAccount = config._account || '';
        config.sid = this.getSid(subAccount);
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        const urlKey = isCorpMail ? 'corpParseIcsFile' : 'icsParse';
        if (isCorpMail) {
            config.part = config.partId;
        }
        const { data } = await this.http.get(this.systemApi.getUrl(urlKey), config, { _account: subAccount });
        if ((data === null || data === void 0 ? void 0 : data.success) || (data === null || data === void 0 ? void 0 : data.code) == 200) {
            if (isCorpMail) {
                const corpResData = data.data || {};
                const res = {
                    method: corpResData.method,
                    propId: corpResData.propId,
                    veventList: corpResData.events,
                };
                IcsApiImpl.normalizeVeventListInvitees(res.veventList);
                return res;
            }
            const result = data.result;
            IcsApiImpl.normalizeVeventListInvitees(result === null || result === void 0 ? void 0 : result.veventList);
            return result;
        }
        return Promise.reject(data === null || data === void 0 ? void 0 : data.message);
    }
    getIcsInfoParams(res, attendee, _account) {
        var _a;
        const email = this.getEmail(_account);
        let url = this.systemApi.getUrl('icsInfo', undefined, undefined, _account);
        const event = res.veventList[0];
        const organizer = (_a = event.organizer) === null || _a === void 0 ? void 0 : _a.extDesc;
        const { propId } = res;
        let infoData;
        let params = {
            organizer,
            uid: event.uid,
            sequence: event.sequence,
            recurrenceId: event.recurrenceId,
        };
        if (organizer === email) {
            if (res.method === 'REQUEST') {
                url += '/organizer/info';
                params = Object.assign(params, {
                    propId,
                    event,
                });
            }
            else if (res.method === 'REPLY') {
                url += '/organizer/resp';
                const matched = event.invitees.find((item) => item.email === attendee);
                params = Object.assign(params, {
                    attendee,
                    lastModified: event.lastModified,
                    partStat: matched === null || matched === void 0 ? void 0 : matched.partStat,
                    event,
                });
            }
            else {
                infoData = {
                    event: res.veventList[0],
                    cancel: 1,
                    change: 0,
                    expired: 0,
                    support: 1,
                };
            }
        }
        else {
            url += '/attendee/info';
            params = event;
        }
        return {
            url,
            params,
            infoData,
            event,
            method: res.method,
        };
    }
    static normalizeEventInvitees(ev) {
        if (ev && ev.invitees == null) {
            ev.invitees = [];
        }
    }
    static normalizeVeventListInvitees(veventList) {
        if (!(veventList === null || veventList === void 0 ? void 0 : veventList.length)) {
            return;
        }
        veventList.forEach(ev => IcsApiImpl.normalizeEventInvitees(ev));
    }
    static transformIcsModel(data) {
        const icsData = Object.assign({}, data);
        if (icsData.event) {
            IcsApiImpl.normalizeEventInvitees(icsData.event);
            if (icsData.event.recur && icsData.event.recur.until) {
                icsData.event.recur.until = util.getDateTime(icsData.event.recur.until);
            }
        }
        return icsData;
    }
    async doGetIcsInfo(config) {
        try {
            const res = await this.getIcsParse(config);
            const uid = this.getEmail(config === null || config === void 0 ? void 0 : config._account);
            const { url, params, infoData, event, method } = this.getIcsInfoParams(res, config.attendee, config === null || config === void 0 ? void 0 : config._account);
            if (infoData) {
                return IcsApiImpl.transformIcsModel(infoData);
            }
            const { data } = await this.http.post(this.http.buildUrl(url, {
                uid,
                method,
            }), params, { contentType: 'json', _account: config === null || config === void 0 ? void 0 : config._account });
            const rs = data.data;
            rs.method = method;
            rs.hasEvent = !!(rs === null || rs === void 0 ? void 0 : rs.event);
            const mergedEvent = await this.getFreeBusyInfo((rs === null || rs === void 0 ? void 0 : rs.event) || event || {});
            IcsApiImpl.normalizeEventInvitees(mergedEvent);
            rs.event = mergedEvent;
            return IcsApiImpl.transformIcsModel(rs);
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    async getFreeBusyInfo(event) {
        const { startTime, endTime } = event;
        if (startTime || endTime) {
            const res = await this.catalogApi.doGetFreeBusyList({
                users: [this.getEmail()],
                start: util.getDateTime(startTime),
                end: util.getDateTime(endTime),
            });
            const mStart = moment(startTime);
            const mEnd = moment(endTime);
            event.conflict = res[0].freeBusyItems
                .filter(free => {
                const curStart = moment(free.start);
                const curEnd = moment(free.end);
                return free.uid !== event.uid && util.rangeInteract([mStart, mEnd], [curStart, curEnd]);
            })
                .sort((ea, eb) => {
                const ead = ea.end - ea.start;
                const ebd = eb.end - eb.start;
                if (ead !== ebd) {
                    return ead - ebd;
                }
                return ea.start - eb.start;
            });
        }
        return event;
    }
    getCommonSearchParams(_account) {
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        const currentUser = this.systemApi.getCurrentUser(_account);
        return {
            sid: isCorpMail ? currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId : '',
        };
    }
    async doOperateIcs(config) {
        const uid = this.getEmail(config === null || config === void 0 ? void 0 : config._account);
        const url = this.http.buildUrl(this.systemApi.getUrl('icsOperate', undefined, undefined, config === null || config === void 0 ? void 0 : config._account), Object.assign({ uid }, this.getCommonSearchParams(config === null || config === void 0 ? void 0 : config._account)));
        const { data } = await this.http.post(url, config, { contentType: 'json', _account: config === null || config === void 0 ? void 0 : config._account });
        return data.data;
    }
    getSid(email) {
        const user = this.systemApi.getCurrentUser(email);
        return (user === null || user === void 0 ? void 0 : user.sessionId) || '';
    }
    getEmail(_account) {
        const user = this.systemApi.getCurrentUser(_account);
        return (user === null || user === void 0 ? void 0 : user.id) || '';
    }
    init() {
        return this.name;
    }
    afterInit() {
        return this.name;
    }
}
const icsApiImpl = new IcsApiImpl();
api.registerLogicalApi(icsApiImpl);
export default icsApiImpl;
